export const usesPublicShell = (route) => {
  const section = route && route.meta && route.meta.section;
  const name = route && route.name;

  return (
    section === 'home' ||
    section === 'legal' ||
    name === 'Register' ||
    name === 'Upgrade' ||
    name === 'Verification Required'
  );
};
